// Login.jsx
import React, { useState } from "react";
import { FaUser, FaLock, FaSignInAlt } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";





const Login = ({ onLoginSuccess }) => { 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = async () => {
    console.log("👉 Login button clicked");

    setLoading(true);
    setError("");

    if (!email || !password) {
      setError("Please enter email and password.");
      setLoading(false);
      return;
    }

    console.log("📤 Sending API request with:", { email, password });

    try {
      const response = await axios.post(
        "https://tailor.beezetsoftwaresolution.com/api/auth/login.php",
        { email, password }
      );

      console.log("✅ API Response:", response.data);

      if (response.data.status === "success") {
        Cookies.set("tailor_auth_status", true, { expires: 7 });
        localStorage.setItem("admin_id", response.data.admin_id);

        console.log("🎉 Login Success → Redirecting to Dashboard");

        if (onLoginSuccess) onLoginSuccess();   // 👈 CALL PARENT

        navigate("/");  // 👈 CORRECT DASHBOARD ROUTE
      } else {
        setError(response.data.message || "Login failed");
      }
    } catch (err) {
      console.log("🚨 API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      console.log("🔚 API call finished");
      setLoading(false);
    }
  };

  

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-gray-900 px-4">
      <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl w-full max-w-sm border border-white/20">
        <h2 className="text-center text-3xl font-semibold text-white mb-6">
          BEEZET TAILORING
        </h2>

        {error && <p className="text-red-400 text-center mb-4">{error}</p>}

        <div className="mb-4">
          <div className="flex items-center border border-white/30 rounded-lg px-3 py-2 bg-white/10 text-white">
            <FaUser className="mr-2" />
            <input
              type="email"
              placeholder="Email"
              className="bg-transparent outline-none w-full text-white"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="mb-6">
          <div className="flex items-center border border-white/30 rounded-lg px-3 py-2 bg-white/10 text-white">
            <FaLock className="mr-2" />
            <input
              type="password"
              placeholder="Password"
              className="bg-transparent outline-none w-full text-white"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full bg-emerald-400 hover:bg-emerald-500 text-white py-2 rounded-lg flex justify-center items-center"
        >
          <FaSignInAlt className="mr-2" />
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="text-center text-xs text-gray-300 mt-4">Secured by Beezet</p>
      </div>
    </div>
  );
};

export default Login;
